import moment from "moment";

export const DATEPICKER_RANGES = {
  "Today": [
  	moment().startOf("day"),
  	moment().endOf("day")
	],
  "Yesterday": [
    moment().subtract(1, "days").startOf("day"),
    moment().subtract(1, "days").endOf("day")
  ],
  "Last 7 Days": [
    moment().subtract(6, "days").startOf("day"),
    moment().endOf("day")
  ],
  "Last 30 Days": [
    moment().subtract(29, "days").startOf("day"),
    moment().endOf("day")
  ],
  "This Month": [
  	moment().startOf("month"),
  	moment().endOf("month")
  ],
  "Last Month": [
    moment().subtract(1, "month").startOf("month"),
    moment().subtract(1, "month").endOf("month")
  ],
  "This Quarter": [
    moment().quarter(moment().quarter()).startOf("quarter"),
    moment().quarter(moment().quarter()).endOf("quarter")
  ],
  "Last Quarter": [
    moment().subtract(1, "quarter").startOf("quarter"),
    moment().subtract(1, "quarter").endOf("quarter")
  ],
  "This Year": [
    moment().year(moment().year()).startOf("year"),
    moment().year(moment().year()).endOf("year")
  ],
  "Last Year": [
    moment().subtract(1, "year").startOf("year"),
    moment().subtract(1, "year").endOf("year")
  ]
};

export const DATE15MIN = {
  dateFrom: moment().tz("Europe/Berlin").subtract(15, 'minutes').format("YYYY-MM-DD"),
  dateTo: moment().tz("Europe/Berlin").format("YYYY-MM-DD"),
  datetimeFrom: moment().tz("Europe/Berlin").subtract(15, 'minutes').format("YYYY-MM-DDTHH:mm:ss"),
  datetimeTo: moment().tz("Europe/Berlin").format("YYYY-MM-DDTHH:mm:ss")
};

export const DATE1MONTH = {
  dateFrom: moment().startOf("month").format("YYYY-MM-DD"),
  dateTo: moment().endOf("day").format("YYYY-MM-DD"),
  datetimeFrom: moment().startOf("month").format("YYYY-MM-DDTHH:mm:ss"),
  datetimeTo: moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss")
};

export const BIN_REGION = [
  { label: "International", value: "INTERNATIONAL" },
  { label: "Europe", value: "EUROPE" },
  { label: "Domestic", value: "DOMESTIC"},
];

export const BIN_REGION_BY_ID = {
  INTERNATIONAL: "International",
  EUROPE: "Europe",
  DOMESTIC: "Domestic"
};

export const COUNTRY_CODES = [
  { label: "AFG", value: "AFG" },
  { label: "ALA", value: "ALA" },
  { label: "ALB", value: "ALB" },
  { label: "DZA", value: "DZA" },
  { label: "ASM", value: "ASM" },
  { label: "AND", value: "AND" },
  { label: "AGO", value: "AGO" },
  { label: "AIA", value: "AIA" },
  { label: "ATA", value: "ATA" },
  { label: "ATG", value: "ATG" },
  { label: "ARG", value: "ARG" },
  { label: "ARM", value: "ARM" },
  { label: "ABW", value: "ABW" },
  { label: "AUS", value: "AUS" },
  { label: "AUT", value: "AUT" },
  { label: "AZE", value: "AZE" },
  { label: "BHS", value: "BHS" },
  { label: "BHR", value: "BHR" },
  { label: "BGD", value: "BGD" },
  { label: "BRB", value: "BRB" },
  { label: "BLR", value: "BLR" },
  { label: "BEL", value: "BEL" },
  { label: "BLZ", value: "BLZ" },
  { label: "BEN", value: "BEN" },
  { label: "BMU", value: "BMU" },
  { label: "BTN", value: "BTN" },
  { label: "BOL", value: "BOL" },
  { label: "BIH", value: "BIH" },
  { label: "BWA", value: "BWA" },
  { label: "BVT", value: "BVT" },
  { label: "BRA", value: "BRA" },
  { label: "VGB", value: "VGB" },
  { label: "IOT", value: "IOT" },
  { label: "BRN", value: "BRN" },
  { label: "BGR", value: "BGR" },
  { label: "BFA", value: "BFA" },
  { label: "BDI", value: "BDI" },
  { label: "KHM", value: "KHM" },
  { label: "CMR", value: "CMR" },
  { label: "CAN", value: "CAN" },
  { label: "CPV", value: "CPV" },
  { label: "CYM", value: "CYM" },
  { label: "CAF", value: "CAF" },
  { label: "TCD", value: "TCD" },
  { label: "CHL", value: "CHL" },
  { label: "CHN", value: "CHN" },
  { label: "HKG", value: "HKG" },
  { label: "MAC", value: "MAC" },
  { label: "CXR", value: "CXR" },
  { label: "CCK", value: "CCK" },
  { label: "COL", value: "COL" },
  { label: "COM", value: "COM" },
  { label: "COG", value: "COG" },
  { label: "COD", value: "COD" },
  { label: "COK", value: "COK" },
  { label: "CRI", value: "CRI" },
  { label: "CIV", value: "CIV" },
  { label: "HRV", value: "HRV" },
  { label: "CUB", value: "CUB" },
  { label: "CYP", value: "CYP" },
  { label: "CZE", value: "CZE" },
  { label: "DNK", value: "DNK" },
  { label: "DJI", value: "DJI" },
  { label: "DMA", value: "DMA" },
  { label: "DOM", value: "DOM" },
  { label: "ECU", value: "ECU" },
  { label: "EGY", value: "EGY" },
  { label: "SLV", value: "SLV" },
  { label: "GNQ", value: "GNQ" },
  { label: "ERI", value: "ERI" },
  { label: "EST", value: "EST" },
  { label: "ETH", value: "ETH" },
  { label: "FLK", value: "FLK" },
  { label: "FRO", value: "FRO" },
  { label: "FJI", value: "FJI" },
  { label: "FIN", value: "FIN" },
  { label: "FRA", value: "FRA" },
  { label: "GUF", value: "GUF" },
  { label: "PYF", value: "PYF" },
  { label: "ATF", value: "ATF" },
  { label: "GAB", value: "GAB" },
  { label: "GMB", value: "GMB" },
  { label: "GEO", value: "GEO" },
  { label: "DEU", value: "DEU" },
  { label: "GHA", value: "GHA" },
  { label: "GIB", value: "GIB" },
  { label: "GRC", value: "GRC" },
  { label: "GRL", value: "GRL" },
  { label: "GRD", value: "GRD" },
  { label: "GLP", value: "GLP" },
  { label: "GUM", value: "GUM" },
  { label: "GTM", value: "GTM" },
  { label: "GGY", value: "GGY" },
  { label: "GIN", value: "GIN" },
  { label: "GNB", value: "GNB" },
  { label: "GUY", value: "GUY" },
  { label: "HTI", value: "HTI" },
  { label: "HMD", value: "HMD" },
  { label: "VAT", value: "VAT" },
  { label: "HND", value: "HND" },
  { label: "HUN", value: "HUN" },
  { label: "ISL", value: "ISL" },
  { label: "IND", value: "IND" },
  { label: "IDN", value: "IDN" },
  { label: "IRN", value: "IRN" },
  { label: "IRQ", value: "IRQ" },
  { label: "IRL", value: "IRL" },
  { label: "IMN", value: "IMN" },
  { label: "ISR", value: "ISR" },
  { label: "ITA", value: "ITA" },
  { label: "JAM", value: "JAM" },
  { label: "JPN", value: "JPN" },
  { label: "JEY", value: "JEY" },
  { label: "JOR", value: "JOR" },
  { label: "KAZ", value: "KAZ" },
  { label: "KEN", value: "KEN" },
  { label: "KIR", value: "KIR" },
  { label: "PRK", value: "PRK" },
  { label: "KOR", value: "KOR" },
  { label: "KWT", value: "KWT" },
  { label: "KGZ", value: "KGZ" },
  { label: "LAO", value: "LAO" },
  { label: "LVA", value: "LVA" },
  { label: "LBN", value: "LBN" },
  { label: "LSO", value: "LSO" },
  { label: "LBR", value: "LBR" },
  { label: "LBY", value: "LBY" },
  { label: "LIE", value: "LIE" },
  { label: "LTU", value: "LTU" },
  { label: "LUX", value: "LUX" },
  { label: "MKD", value: "MKD" },
  { label: "MDG", value: "MDG" },
  { label: "MWI", value: "MWI" },
  { label: "MYS", value: "MYS" },
  { label: "MDV", value: "MDV" },
  { label: "MLI", value: "MLI" },
  { label: "MLT", value: "MLT" },
  { label: "MHL", value: "MHL" },
  { label: "MTQ", value: "MTQ" },
  { label: "MRT", value: "MRT" },
  { label: "MUS", value: "MUS" },
  { label: "MYT", value: "MYT" },
  { label: "MEX", value: "MEX" },
  { label: "FSM", value: "FSM" },
  { label: "MDA", value: "MDA" },
  { label: "MCO", value: "MCO" },
  { label: "MNG", value: "MNG" },
  { label: "MNE", value: "MNE" },
  { label: "MSR", value: "MSR" },
  { label: "MAR", value: "MAR" },
  { label: "MOZ", value: "MOZ" },
  { label: "MMR", value: "MMR" },
  { label: "NAM", value: "NAM" },
  { label: "NRU", value: "NRU" },
  { label: "NPL", value: "NPL" },
  { label: "NLD", value: "NLD" },
  { label: "ANT", value: "ANT" },
  { label: "NCL", value: "NCL" },
  { label: "NZL", value: "NZL" },
  { label: "NIC", value: "NIC" },
  { label: "NER", value: "NER" },
  { label: "NGA", value: "NGA" },
  { label: "NIU", value: "NIU" },
  { label: "NFK", value: "NFK" },
  { label: "MNP", value: "MNP" },
  { label: "NOR", value: "NOR" },
  { label: "OMN", value: "OMN" },
  { label: "PAK", value: "PAK" },
  { label: "PLW", value: "PLW" },
  { label: "PSE", value: "PSE" },
  { label: "PAN", value: "PAN" },
  { label: "PNG", value: "PNG" },
  { label: "PRY", value: "PRY" },
  { label: "PER", value: "PER" },
  { label: "PHL", value: "PHL" },
  { label: "PCN", value: "PCN" },
  { label: "POL", value: "POL" },
  { label: "PRT", value: "PRT" },
  { label: "PRI", value: "PRI" },
  { label: "QAT", value: "QAT" },
  { label: "REU", value: "REU" },
  { label: "ROU", value: "ROU" },
  { label: "RUS", value: "RUS" },
  { label: "RWA", value: "RWA" },
  { label: "BLM", value: "BLM" },
  { label: "SHN", value: "SHN" },
  { label: "KNA", value: "KNA" },
  { label: "LCA", value: "LCA" },
  { label: "MAF", value: "MAF" },
  { label: "SPM", value: "SPM" },
  { label: "VCT", value: "VCT" },
  { label: "WSM", value: "WSM" },
  { label: "SMR", value: "SMR" },
  { label: "STP", value: "STP" },
  { label: "SAU", value: "SAU" },
  { label: "SEN", value: "SEN" },
  { label: "SRB", value: "SRB" },
  { label: "SYC", value: "SYC" },
  { label: "SLE", value: "SLE" },
  { label: "SGP", value: "SGP" },
  { label: "SVK", value: "SVK" },
  { label: "SVN", value: "SVN" },
  { label: "SLB", value: "SLB" },
  { label: "SOM", value: "SOM" },
  { label: "ZAF", value: "ZAF" },
  { label: "SGS", value: "SGS" },
  { label: "SSD", value: "SSD" },
  { label: "ESP", value: "ESP" },
  { label: "LKA", value: "LKA" },
  { label: "SDN", value: "SDN" },
  { label: "SUR", value: "SUR" },
  { label: "SJM", value: "SJM" },
  { label: "SWZ", value: "SWZ" },
  { label: "SWE", value: "SWE" },
  { label: "CHE", value: "CHE" },
  { label: "SYR", value: "SYR" },
  { label: "TWN", value: "TWN" },
  { label: "TJK", value: "TJK" },
  { label: "TZA", value: "TZA" },
  { label: "THA", value: "THA" },
  { label: "TLS", value: "TLS" },
  { label: "TGO", value: "TGO" },
  { label: "TKL", value: "TKL" },
  { label: "TON", value: "TON" },
  { label: "TTO", value: "TTO" },
  { label: "TUN", value: "TUN" },
  { label: "TUR", value: "TUR" },
  { label: "TKM", value: "TKM" },
  { label: "TCA", value: "TCA" },
  { label: "TUV", value: "TUV" },
  { label: "UGA", value: "UGA" },
  { label: "UKR", value: "UKR" },
  { label: "ARE", value: "ARE" },
  { label: "GBR", value: "GBR" },
  { label: "USA", value: "USA" },
  { label: "UMI", value: "UMI" },
  { label: "URY", value: "URY" },
  { label: "UZB", value: "UZB" },
  { label: "VUT", value: "VUT" },
  { label: "VEN", value: "VEN" },
  { label: "VNM", value: "VNM" },
  { label: "VIR", value: "VIR" },
  { label: "WLF", value: "WLF" },
  { label: "ESH", value: "ESH" },
  { label: "YEM", value: "YEM" },
  { label: "ZMB", value: "ZMB" },
  { label: "ZWE", value: "ZWE" }
];

export const DATEPICKER_LOCALE = {
  format: "DD-MM-YYYY HH:mm:ss",
  separator: " - ",
  applyLabel: "Apply",
  cancelLabel: "Cancel",
  fromLabel: "From",
  toLabel: "To",
  customRangeLabel: "Custom",
  weekLabel: "W",
  daysOfWeek: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  monthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  firstDay: 1
};

export const TX_LOG_FILTERS = {
  order: {
    id: 'order_id',
    title: 'Order ID',
    type: 'input'
  },
  ps_name: {
    id: 'ps_name',
    title: 'Acquirer',
    type: 'select'
  },
  transaction_id: {
    id: 'transaction_id',
    title: 'Transaction ID',
    type: 'input'
  },
  email: {
    id: 'email',
    title: 'E-Mail-Address',
    type: 'input'
  },
  company: {
    id: 'merchant_company_id',
    title: 'Company',
    type: 'select'
  },
  currency: {
    id: 'currency',
    title: 'Currency',
    type: 'select'
  },
  card_brand: {
    id: 'card_brand',
    title: 'Card Scheme',
    type: 'select'
  },
  bin_country: {
    id: 'bin_country',
    title: 'BIN Country',
    type: 'select'
  },
  bin_region: {
    id: 'bin_region',
    title: 'Bin Region',
    type: 'select'
  },
  ip_country: {
    id: 'ip_country',
    title: 'IP Country',
    type: 'select'
  },
  ccn_masked: {
    id: 'ccn_masked',
    title: '424242******4242',
    type: 'input'
  }
}

export const FINANCE_FILTERS = {
  merchant_company_id: {
    id: 'merchant_company_id',
    title: 'Company',
    type: 'select'
  },
  currency: {
    id: 'currency',
    title: 'Currency',
    type: 'select'
  },
  acquirer_mid: {
    id: 'acquirer_mid',
    title: 'Mid',
    type: 'select'
  },
  card_brand: {
    id: 'card_brand',
    title: 'Card Scheme',
    type: 'select'
  },
  bin_country: {
    id: 'bin_country',
    title: 'BIN Country',
    type: 'select'
  },
  bin_region: {
    id: 'bin_region',
    title: 'Bin Region',
    type: 'select'
  },
  ip_country: {
    id: 'ip_country',
    title: 'IP Country',
    type: 'select'
  }
}

export const DEFAULT_FILTERS = {
  pm_name: {
    id: 'pm_name',
    title: 'Payment Method',
    type: 'select'
  },
  ps_name: {
    id: 'ps_name',
    title: 'Acquirer',
    type: 'select'
  },
  merchant_name: {
    id: 'merchant_name',
    title: 'Merchant',
    type: 'select'
  },
  company: {
    id: 'merchant_company_id',
    title: 'Company',
    type: 'select'
  },
  currency: {
    id: 'currency',
    title: 'Currency',
    type: 'select'
  },
  card_brand: {
    id: 'card_brand',
    title: 'Card Scheme',
    type: 'select'
  },
  bin_country: {
    id: 'bin_country',
    title: 'BIN Country',
    type: 'select'
  },
  bin_region: {
    id: 'bin_region',
    title: 'Bin Region',
    type: 'select'
  },
  ip_country: {
    id: 'ip_country',
    title: 'IP Country',
    type: 'select'
  }
}

export const TX_ADVANCED_FILTER = {
  order_id: {
    id: 'order_id',
    title: 'Order-ID',
    type: 'input'
  },
  transaction_id: {
    id: 'transaction_id',
    title: 'Transaction-ID',
    type: 'input'
  },
  transaction_status: {
    id: 'transaction_status',
    title: 'All Status',
    type: 'select'
  },
  error_code: {
    id: 'error_code',
    title: 'Error-Code',
    type: 'input'
  },
  fraud_transactions: {
    id: 'fraud_transactions',
    title: 'Fraud Transactions',
    type: 'checkbox'
  },
  recurring_flag: {
    id: 'recurring_flag',
    title: 'Recurring Transactions',
    type: 'checkbox'
  },
  token_id: {
    id: 'token_id',
    title: 'Tokenized Transactions',
    type: 'checkbox'
  },
  cvc_flag: {
    id: 'cvc_flag',
    title: 'Transactions with cvc',
    type: 'checkbox'
  },
  transaction_type: {
    id: 'transaction_type',
    title: 'All Transaction Types',
    type: 'select'
  },
  currency: {
    id: 'currency',
    title: 'All Currencies',
    type: 'select'
  },
  merchant_name: {
    id: 'merchant_name',
    title: 'All Merchant Names',
    type: 'select'
  },
  merchant_company_id: {
    id: 'merchant_company_id',
    title: 'All Merchant Companies',
    type: 'select'
  },
  pm_name: {
    id: 'pm_name',
    title: 'All Payment Methods',
    type: 'select'
  }
}

export const TX_ADVANCED_FILTER2 = {
  customer_id: {
    id: 'customer_id',
    title: 'Customer No',
    type: 'input'
  },
  firstname: {
    id: 'firstname',
    title: 'First Name',
    type: 'input'
  },
  lastname: {
    id: 'lastname',
    title: 'Last Name',
    type: 'input'
  },
  email: {
    id: 'email',
    title: 'Email-Address',
    type: 'input'
  },
  custom_1: {
    id: 'custom_1',
    title: 'Custom1',
    type: 'input'
  },
  custom_2: {
    id: 'custom_2',
    title: 'Custom2',
    type: 'input'
  },
  custom_3: {
    id: 'custom_3',
    title: 'Custom3',
    type: 'input'
  },
  rrn: {
    id: 'rrn',
    title: 'RRN',
    type: 'input'
  },
  arn: {
    id: 'arn',
    title: 'ARN',
    type: 'input'
  },
  external_id: {
    id: 'external_id',
    title: 'External Id',
    type: 'input'
  },
  refund_comment: {
    id: 'refund_comment',
    title: 'Refund Comment',
    type: 'input'
  }
}

export const CHARGEBACK_ALERTS_FILTERS = {
  transaction_id: {
    id: "transaction_id",
    title: "Transaction ID",
    type: "input",
  },
  currency: {
    id: "dispute_provider_transaction_currency",
    title: "Currency",
    type: "select",
  },
  card_brand: {
    id: "card_brand",
    title: "Card Scheme",
    type: "select",
  },
  bin_country: {
    id: "bin_country",
    title: "BIN Country",
    type: "select",
  },
  chargeback_provider: {
    id: "chargeback_alert_type",
    title: "Provider",
    type: "select",
  },
  reason_code: {
    id: "dispute_provider_reason_code",
    title: "Reason Code",
    type: "select",
  },
  chargeback_status: {
    id: "payabl_dispute_status",
    title: "Status",
    type: "select",
  },
};

export const CHARGEBACK_ALERTS_FILTERS_COMPANY = {
  company: {
    id: "merchant_company_id",
    title: "Company",
    type: "select",
  },
};

export const CHARGEBACK_ALERTS_FILTER_MERCHANT = {
  merchant: {
    id: "merchant_name",
    title: "Merchant",
    type: "select",
  },
};

export const SELECTFIELDS = [
  "pm_name",
  "ps_name",
  "merchant_name",
  "merchant_company_id",
  "card_brand",
  "currency",
  "bin_country",
  "bin_region",
  "ip_country"
]

export const CHECKBOXFIELDS = [
  "fraud_transactions",
  "recurring_transactions",
  "recurring_flag",
  "token_id",
  "cvc_flag",
  "include_volume"
]